module.exports = __webpack_public_path__ + "img/admin_adv_02.b16a2226.png";